import PropTypes from 'prop-types'

// Styles
import styles from './style.module.scss'

export const MediaVideo = ({ mediaSrc }) => (
  <div
    className={styles.media_wrapper}
    style={{
      backgroundImage: `url(https://img.youtube.com/vi/${mediaSrc}/0.jpg)`,
    }}>
    <img
      src="data:image/gif;base64,R0lGODlhDAAHAIAAAP///wAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjEgNjQuMTQwOTQ5LCAyMDEwLzEyLzA3LTEwOjU3OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1LjEgV2luZG93cyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBMDAyRDQzNTU0N0ExMUVBQTBEOENDRjQ3MzZEQjhDOCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBMDAyRDQzNjU0N0ExMUVBQTBEOENDRjQ3MzZEQjhDOCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkEwMDJENDMzNTQ3QTExRUFBMEQ4Q0NGNDczNkRCOEM4IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkEwMDJENDM0NTQ3QTExRUFBMEQ4Q0NGNDczNkRCOEM4Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAQAAAAAsAAAAAAwABwAAAgiEj6nL7Q9VAQA7"
      alt=""
    />
    <iframe
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${mediaSrc}`}
      frameBorder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title={mediaSrc}
    />
  </div>
)

MediaVideo.propTypes = {
  mediaSrc: PropTypes.string.isRequired,
}

export default MediaVideo
